export default __webpack_public_path__ + "static/media/leaf4.98c1aa26.png";